import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { IAuthorizableGranteePermissions } from './IAuthorizableGranteePermissions';

export interface ISetExplicitPermissionsParams {
  permissions: IAuthorizableGranteePermissions[];
}

export interface ISetExplicitPermissionsResult extends IResult {
}

export class SetExplicitPermissionsRequest extends Request<ISetExplicitPermissionsParams, ISetExplicitPermissionsResult> {
  constructor(params: ISetExplicitPermissionsParams) {
    super('setExplicitPermissions', params);
  }
}
